import React, { useMemo } from "react";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import ProjectTable from "pages/components/ProjectTable/ProjectTable";
import DialogApuramentoHeader from "pages/comercial/components/DialogApuramentoHeader";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

export default function DialogIncentivoResultados({
  PaperComponent,
  open,
  onClose,
  incentivo,
  periodo,
  setPeriodo,
  resultados,
  loading,
  onConsultar,
  abrirResultadoDetalhe,
}) {
  const columns = useMemo(
    () => [
      { Header: "Vendedor", accessor: "vendedor", width: 220 },
      // { Header: "Incentivo", accessor: "incentivo", width: 200 },
      { Header: "Grupo", accessor: "grupo", width: 150 },
      { Header: "Patamar", accessor: "patamar", width: 150 },
      {
        Header: "Faturação",
        accessor: "obtido",
        width: 300,
      },
      {
        Header: "Condições necessárias",
        accessor: "condicoes",
        width: 360,
      },
      {
        Header: "Prémio",
        accessor: "beneficio_descricao",
        width: 320,
      },

      {
        Header: "Estado",
        accessor: "atingido",
        width: 120,
        Cell: ({ value }) => (value ? "Atingido" : "Não atingido"),
      },
      {
        Header: "Prémio alcançado",
        accessor: "beneficio_obtido",
        width: 160,
        Cell: ({ value }) => value || "",
      },
    ],
    []
  );

  const rowActions = useMemo(
    () => [
      {
        id: "detalhe",
        icon: <InfoOutlinedIcon fontSize="small" />,
        tooltip: "Ver clientes e faturas",
        color: "info",
        onClick: abrirResultadoDetalhe,
      },
    ],
    [abrirResultadoDetalhe]
  );

  const totalApurado = useMemo(
    () =>
      (Array.isArray(resultados) ? resultados : []).reduce(
        (total, linha) => total + Number(linha?.beneficio_obtido || 0),
        0
      ),
    [resultados]
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      PaperComponent={PaperComponent}
      PaperProps={{
        sx: {
          width: { xs: "calc(100% - 24px)", xl: "1450px" },
          maxWidth: "100%",
          height: { xs: "94vh", md: "92vh" },
          maxHeight: { xs: "94vh", md: "92vh" },
          m: { xs: 1.5, md: 3 },
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
        Resultados do incentivo
      </DialogTitle>

      <DialogContent
        sx={{
          px: { xs: 1.5, md: 3 },
          maxWidth: "100%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        }}
      >
        <MDBox
          display="grid"
          gridTemplateRows="auto minmax(0, 1fr)"
          gap={2}
          mt={1}
          height="100%"
          minHeight={0}
        >
          <DialogApuramentoHeader
            tipo="Incentivo"
            id={incentivo?.id}
            nome={incentivo?.nome}
            fabricante={incentivo?.fabricante || incentivo?.reffabricante}
            periodo={periodo}
            setPeriodo={setPeriodo}
            total={totalApurado}
            loading={loading}
            onRecalcular={onConsultar}
          />

          <MDBox minHeight={0} minWidth={0}>
            <ProjectTable
              tableKey="incentivos-resultados"
              version="v1"
              columns={columns}
              data={Array.isArray(resultados) ? resultados : []}
              loading={loading}
              rowActions={rowActions}
              minWidth={900}
              maxHeight="40vh"
              emptyMessage="Sem resultados para apresentar."
              actionsPosition="left"
            />
          </MDBox>
        </MDBox>
      </DialogContent>

      <DialogActions>
        <MDButton color="secondary" onClick={onClose}>
          Fechar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
